import React from 'react';
import classNames from 'classnames/bind';

class SelectImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.multi === true ? props.value ? props.value : [] : props.value ? props.value : ''
        };
        this.onChange = this.onChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return {
            value: props.value
        }
    }

    onChange(option) {
        let { value } = this.state;
        const { name, multi } = this.props;
        if (multi === true) {
            if (value.includes(option.value)) {
                value = value.filter(v => v != option.value);
            } else {
                value = [...value, option.value]
            }
        } else {
            if (value == option.value) {
                value = '';
            } else {
                value = option.value;
            }
        }
        this.props.onChange({ name, value })
    }

    isSelected(multi, value, loopValue) {
        if (multi === true) {
            return value.includes(loopValue)
        } else {
            return value != '' && value == loopValue;
        }
    }

    render() {
        const { options, name, className, multi, readOnly } = this.props;
        const { value } = this.state;

        return (
            <ul className={"tile-types d-flex justify-content-start"}>
                {
                    options.map((o, i) => {
                        const selected = this.isSelected(multi, value, o.value);
                        const liClassNames = classNames({
                            'selected': selected,
                            'cursor-not-allowed': readOnly
                        })
                        const imgClassName = classNames({
                            'cursor-not-allowed': readOnly
                        });
                        return (
                            <li title={o.text} key={name + o.value} onClick={() => readOnly ? '' : this.onChange(o)} className={liClassNames}>
                                {
                                    selected &&
                                    <span className="sel"><i className="fas fa-check"></i></span>
                                }
                                <a><img className={imgClassName} src={o.optionImageUrl} /></a>
                            </li>
                        )
                    }
                    )
                }
            </ul>
        );
    }
}

export default SelectImage;